<main [@fadeInOut] id="main-heading" role="main" tabindex="0" class="container-fluid d-flex">
  <div class="col-sm-11 mx-auto d-flex flex-column main-heading-div">
    <div class="row mt-3 main-heading-div">
      <h1 class="ps-3" tabindex="0">Manage DI</h1>
      <div class="col-md-12 d-flex flex-row justify-content-end">
        <div class="col-md-12" *ngIf="revalidating; else nonLanguage">
          <div class="col-sm-12 d-flex justify-content-between">

            <div class="col-md-9 banner" *ngIf='gridComplete && pageLoaded'>
              <div class="col-md-12 d-flex shadow-lg py-2 inner-banner">
                <div class="col-md-5 col-lg-3 col-xl-3 justify-content-start px-3">
                  <div class="d-flex flex-column progress-bar-div">
                    <ejs-progressbar #circular id='circular' cornerRadius='Square' [type]='pbType' [value]='circularVal'
                                     [width]='pbWidth' [trackThickness]='trackThickness' [progressThickness]='progressThickness'
                                     [segmentCount]='segmentCount' progressColor="#0071bb" [showProgressValue]='showProgressValue'
                                     [gapWidth]='gapWidth' [startAngle]='startAngle' [endAngle]='endAngle' [height]='pbHeight'
                                     [animation]='animation' (load)='loadProgressBar($event)' [maximum]='circularMax'
                                     [minimum]='circularMin' (progressCompleted)='progressCompleted($event)'
                                     (valueChanged)='valueChanged($event)' class="progressBar">
                    </ejs-progressbar>
                    <span class="badge mx-auto ps-2 py-1 processed-counter" *ngIf="processedCounter">{{processedCounter}} of
                      {{circularMax}}</span>
                  </div>
                </div>
                <div class="col-md-7 col-lg-9 col-xl-9 align-self-start pt-1 px-2 align-self-center">
                  <blockquote class="blockquote">
                    We are in the process of refreshing data with the updated changes made to the display language.
                    While this is occurring the grids will be repopulated with the changes, and some data may not be
                    displayed until this process has been completed.
                  </blockquote>
                </div>
              </div>
            </div>


            <div class="col-md-3 align-self-end justify-content-end text-right">
              <button class="btn btn-primary btn-sm" (click)="saveUserPrefs()" *ngIf='gridComplete'
                      aria-label="Save Grid Preferences" tabindex="0">
                Save Grid Preferences <i class="far fa-floppy-disk nbsp-padding-left"></i>
              </button>
            </div>
          </div>
        </div>
        <ng-template #nonLanguage>
          <div class="col-md-12 d-flex justify-content-end">
            <button class="btn btn-primary btn-sm" (click)="saveUserPrefs()" *ngIf='gridComplete'
                    aria-label="Save Grid Preferences" tabindex="0">
              Save Grid Preferences <i class="fa-light fa-floppy-disk nbsp-padding-left"></i>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="row" [hidden]="!gridComplete" role="region" aria-label="grid region" tabindex="0">
      <div class="col-sm-12 top-space">

        <nav ngbNav #tabset="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" class="nav-tabs" tabindex="0">
          <ng-container ngbNavItem="model" *ngIf="dataScopeEudamed || dataScopeSwissdamed">
            <a ngbNavLink role="tab" tabindex="0">
              <div #leadingTab id="leading-tab">
                <span aria-label="Model View">Model View</span>
              </div>
            </a>
            <ng-template ngbNavContent>
              <div *ngIf="!showLegacyModelGrid; then regulationModelTemplate else legacyModelTemplate"></div>
              <ng-template #regulationModelTemplate>
                <div [@fadeInOut] class="row bottom-padding">
                  <div class="col-sm-12" aria-label="model tab grid area">
                    <div class="col-sm-12 d-flex my-2">
                      <div class="col-sm-2">
                        <span aria-label="Results returned">
                          Results Returned:<span class="badge warning-background badge-bottom-margin  mx-1">
                            {{deviceCount}}
                          </span>records
                        </span>
                      </div>
                      <div class="col-sm-10">
                        <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked" *ngIf="shouldShowSelectAllCheckbox()">
                        </ejs-checkbox>
                        <span *ngIf="shouldShowSelectedCount()" class="ps-3 text-primary">Selected<span
                            class="badge  mx-1">
                            {{getSelectedItemsCount()}}</span>{{itemType === 'model' ? 'models' : 'devices'}} </span>
                      </div>
                    </div>
                    <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)"
                      [enableHtmlParse]="false" target=".e-ellipsistooltip">
                      <ejs-grid #grid [dataSource]="data" allowPaging="true" class="grid-striped" pageSizes="true | []"
                        [pageSettings]="pageOptions" [filterSettings]="filterSettings" [showColumnChooser]="true"
                        [toolbar]="toolbar" (toolbarClick)='toolbarClick($event)' [allowSorting]="true"
                        [allowFiltering]="true" allowScrolling="true" [allowReordering]="true"
                        (dataStateChange)="dataStateChange($event)" (actionComplete)="complete($event)"
                        (actionBegin)="actionBegin($event)" (beforeOpenColumnChooser)="checkboxClick($event)"
                        (dataBound)="dataBound($event)" (created)="gridCreated($event)" (actionFailure)="failure($event)"
                        (load)="load()" height="500" [allowSelection]="shouldAllowRowSelection()" [selectionSettings]="selectionOptions"
                        (rowDeselected)="rowDeselectedItem($event, 'id')" (rowSelected)="rowSelectedItem($event, 'id')"
                        (mouseover)="tooltipValue($event)" (keyPressed)="setSelectedRowIndex($event)">
                        <e-columns>
                          <e-column *ngIf="shouldAllowRowSelection()" field='select' type='checkbox' width='40' [allowFiltering]="false"
                                    [allowSorting]="false" [showInColumnChooser]='false' class='no-border'>
                          </e-column>
                          <e-column type='string' field='Basic UDI-DI' headerText='Basic UDI-DI' width='300'
                                    isPrimaryKey='true' clipMode='EllipsisWithTooltip' [allowSorting]="false">
                            <ng-template #template let-data>
                              <a href="javascript:void(0)" class="pointer" (keydown)="keydownEnter($event)"
                                 (click)="itemClicked($event)">
                                {{data["Basic UDI-DI"]}}
                              </a>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Basic UDI-DI Issuing Agency'
                                    headerText='Basic UDI-DI Issuing Agency' width='250' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Modified By' headerText='Modified By' width='250'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='date' field='Modified Date/Time' headerText='Modified Date/Time' width='210'
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Device Model' headerText='Device Model' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='Device Name' headerText='Device Name' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Applicable Legislation' headerText='Applicable Legislation'
                                    width='250' [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Risk Class' headerText='Risk Class' width='150'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>

                          <e-column type='string' field='Validation Status' headerText='Validation Status' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'
                                    [visible]="dataScope.toLowerCase() !== dataScopeEnum.SWISSDAMED.toLowerCase()"
                                    [showInColumnChooser]="dataScope.toLowerCase() !== dataScopeEnum.SWISSDAMED.toLowerCase()">
                            <ng-template #template let-data>
                              <div class="validation-div" [ngClass]="getCssClass(data)">
                                <span class="tooltip-span"
                                  (mouseover)="showTooltip($event, 'Validation Status')">{{data['Validation
                                  Status']}}</span>
                              </div>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Manufacturer SRN' headerText='Manufacturer SRN' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='Company Model Tracking Number'
                                    headerText='Company Model Tracking Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Company Model Batch Number'
                                    headerText='Company Model Batch Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Manufacturer CHRN'
                                    headerText='Manufacturer CHRN' width='200' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='SPP CHRN'
                                    headerText='SPP CHRN' width='200' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Health Authority Basic UDI-DI State'
                                    headerText='Health Authority Basic UDI-DI State' width='320' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <span class="tooltip-span"
                                    (mouseover)="showTooltip($event, 'Health Authority Basic UDI-DI State')">
                                {{data["Health Authority Basic UDI-DI State"]}}</span>
                            </ng-template>
                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </ejs-tooltip>
                  </div>
                </div>
              </ng-template>
              <ng-template #legacyModelTemplate>
                <div [@fadeInOut] class="row bottom-padding">
                  <div class="col-sm-12" aria-label="model tab grid area">
                    <div class="col-sm-12 d-flex my-2">
                      <div class="col-sm-2">
                        <span aria-label="Results returned">
                          Results Returned:<span class="badge warning-background badge-bottom-margin  mx-1">
                            {{deviceCount}}
                          </span>records
                        </span>
                      </div>
                      <div class="col-sm-10">
                        <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked" *ngIf="shouldShowSelectAllCheckbox()">
                        </ejs-checkbox>
                        <span *ngIf="shouldShowSelectedCount()" class="ps-3 text-primary">Selected<span
                            class="badge  mx-1">
                            {{getSelectedItemsCount()}}</span>{{itemType === 'model' ? 'models' : 'devices'}} </span>
                      </div>
                    </div>
                    <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)"
                      [enableHtmlParse]="false" target=".e-ellipsistooltip">
                      <ejs-grid #grid [dataSource]="data" allowPaging="true" class="grid-striped" pageSizes="true | []"
                        [pageSettings]="pageOptions" [filterSettings]="filterSettings" [showColumnChooser]="true"
                        [toolbar]="toolbar" (toolbarClick)='toolbarClick($event)' [allowSorting]="true"
                        [allowFiltering]="true" allowScrolling="true" [allowReordering]="true"
                        (dataStateChange)="dataStateChange($event)" (actionComplete)="complete($event)"
                        (actionBegin)="actionBegin($event)" (beforeOpenColumnChooser)="checkboxClick($event)"
                        (dataBound)="dataBound($event)" (created)="gridCreated($event)" (actionFailure)="failure($event)"
                        (load)="load()"height="500" [allowSelection]="shouldAllowRowSelection()" [selectionSettings]="selectionOptions"
                        (rowDeselected)="rowDeselectedItem($event, 'id')" (rowSelected)="rowSelectedItem($event, 'id')"
                        (mouseover)="tooltipValue($event)" (keyPressed)="setSelectedRowIndex($event)">
                        <e-columns>
                          <e-column *ngIf="shouldAllowRowSelection()" field='select' type='checkbox' width='40' [allowFiltering]="false"
                                    [allowSorting]="false" [showInColumnChooser]='false' class='no-border'>
                          </e-column>
                          <e-column type='string' field='Basic UDI-DI' headerText='EUDAMED DI' width='300'
                                    isPrimaryKey='true' clipMode='EllipsisWithTooltip' [allowSorting]="false">
                            <ng-template #template let-data>
                              <a href="javascript:void(0)" class="pointer" (keydown)="keydownEnter($event)"
                                 (click)="itemClicked($event)">
                                {{data["Basic UDI-DI"]}}
                              </a>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Basic UDI-DI Issuing Agency'
                                    headerText='EUDAMED DI Issuing Agency' width='250' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Modified By' headerText='Modified By' width='250'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='date' field='Modified Date/Time' headerText='Modified Date/Time' width='210'
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Applicable Legislation' headerText='Applicable Legislation'
                                    width='250' [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Risk Class' headerText='Risk Class' width='150'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Validation Status' headerText='Validation Status' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'
                                    [visible]="dataScope.toLowerCase() !== dataScopeEnum.SWISSDAMED.toLowerCase()"
                                    [showInColumnChooser]="dataScope.toLowerCase() !== dataScopeEnum.SWISSDAMED.toLowerCase()">
                            <ng-template #template let-data>
                              <div class="validation-div" [ngClass]="getCssClass(data)">
                                <span class="tooltip-span"
                                  (mouseover)="showTooltip($event, 'Validation Status')">{{data['Validation
                                  Status']}}</span>
                              </div>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Manufacturer SRN' headerText='Manufacturer SRN' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='Company Model Tracking Number'
                                    headerText='Company Model Tracking Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Manufacturer CHRN'
                                    headerText='Manufacturer CHRN' width='200' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Health Authority Basic UDI-DI State'
                                    headerText='Health Authority EUDAMED DI State' width='320' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <span class="tooltip-span"
                                    (mouseover)="showTooltip($event, 'Health Authority Basic UDI-DI State')">
                                {{data["Health Authority Basic UDI-DI State"]}}</span>
                            </ng-template>
                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </ejs-tooltip>
                  </div>
                </div>
              </ng-template>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="device">
            <a ngbNavLink role="tab" tabindex="0">
              <span aria-label="Device View">Device View</span>
            </a>
            <ng-template ngbNavContent>
              <div *ngIf="!showLegacyDeviceGrid; then regulationDeviceTemplate else legacyDeviceTemplate"></div>
              <ng-template #regulationDeviceTemplate>
                <div [@fadeInOut] class="row">
                  <div class="col-sm-12">
                    <div class="col-sm-12 d-flex my-2">
                      <div class="col-sm-2">
                        <span aria-label="Results returned">
                          Results Returned:<span class="badge warning-background badge-bottom-margin  mx-1">
                            {{deviceCount}}
                          </span>records
                        </span>
                      </div>
                      <div class="col-sm-10">
                        <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked" *ngIf="deviceCount > 0">
                        </ejs-checkbox>
                        <span *ngIf="getSelectedItemsCount() > 0" class="ps-3 text-primary">Selected<span
                            class="badge  mx-1">
                            {{getSelectedItemsCount()}}</span>{{itemType === 'model' ? 'models' : 'devices'}} </span>
                      </div>

                    </div>
                    <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)"
                      [enableHtmlParse]="false" target=".e-ellipsistooltip">
                      <ejs-grid #grid [dataSource]="data" allowPaging="true" class="grid-striped" pageSizes="true | []"
                        [pageSettings]="pageOptions" [filterSettings]="filterSettings" [showColumnChooser]="true"
                        [toolbar]="toolbar" (toolbarClick)='toolbarClick($event)' [allowSorting]="true"
                        [allowFiltering]="true" allowScrolling="true" [allowReordering]="true"
                        (dataStateChange)="dataStateChange($event)" (actionBegin)="actionBegin($event)"
                        (actionComplete)="complete($event)" (beforeOpenColumnChooser)="checkboxClick($event)"
                        (dataBound)="dataBound($event)" (created)="gridCreated($event)" (actionFailure)="failure($event)"
                        (load)="load()" height="500" [allowSelection]="true" [selectionSettings]="selectionOptions"
                        (rowDeselected)="rowDeselectedItem($event, 'id')" (keyPressed)="setSelectedRowIndex($event)"
                        (rowSelected)="rowSelectedItem($event, 'id')">

                        <e-columns>
                          <e-column field='select' type='checkbox' width='40' [allowFiltering]="false"
                                    [showInColumnChooser]='false' [visible]='true'>
                          </e-column>
                          <e-column type='string' field='Primary DI' headerText='Primary DI' width='200'
                                    [allowSorting]="false" isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <a href="javascript:void(0)" class="pointer" (keydown)="keydownEnter($event)"
                                 (click)="itemClicked($event)">
                                {{data["Primary DI"]}}
                              </a>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Primary DI Issuing Agency' headerText='Primary DI Issuing Agency'
                                    width='250' clipMode='EllipsisWithTooltip' [allowSorting]="false"></e-column>
                          <e-column type='string' field='Modified By' headerText='Modified By' width='250'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='date' field='Modified Date/Time' headerText='Modified Date/Time' width='210'
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Product SKU' headerText='Product SKU' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Trade Name' headerText='Brand/Trade Name' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Device Description' headerText='Device Description' width='250'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Reference or Catalog Number'
                                    headerText='Reference or Catalog Number' width='280' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Attribute Status' headerText='Attribute Status' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <span class="tooltip-span"
                                    (mouseover)="showTooltip($event, 'Attribute Status')">{{data["Attribute Status"]}}</span>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Validation Status' headerText='Validation Status' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <div class="validation-div" [ngClass]="getCssClass(data)">
                                <span class="tooltip-span"
                                  (mouseover)="showTooltip($event, 'Validation Status')">{{data['Validation
                                  Status']}}</span>
                              </div>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Company Device Tracking Number'
                                    headerText='Company Device Tracking Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>

                          <e-column type='string' field='Company Device Batch Number'
                                    headerText='Company Device Batch Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Applicable Submission Channels'
                                    headerText='Applicable Submission Channels' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='Basic UDI-DI Number' headerText='Basic UDI-DI' width='300'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Basic UDI-DI Issuing Agency'
                                    headerText='Basic UDI-DI Issuing Agency' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Basic UDI-DI Attribute Status'
                                    headerText='Basic UDI-DI Attribute Status' width='250' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'
                                    [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()"
                                    [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()"></e-column>
                          <e-column type='string' field='Version or Model' headerText='Version or Model' width='180'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='NMPA Classification Code' headerText='NMPA Classification Code'
                                    width='250' [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>

                          <e-column type='string' field='Health Authority UDI-DI State'
                                    headerText='Health Authority UDI-DI State' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'
                                    [visible]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()"
                                    [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
                            <ng-template #template let-data>
                              <span class="tooltip-span"
                                    (mouseover)="showTooltip($event, 'Health Authority UDI-DI State')">
                                {{data["Health Authority UDI-DI State"]}}</span>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Unified Social Credit Code'
                                    headerText='Unified Social Credit Code' width='250' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='GMDN Codes' headerText='GMDN Code(s)' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='Labeler DUNS Number' headerText='Labeler DUNS Number' width='230'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='FDA Product Codes' headerText='FDA Product Code(s)' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type='string' field='Company Product Cross Reference DI' headerText='Company Product Cross Reference DI' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="Sponsor ID" headerText="Sponsor ID" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="ARTG IDs" headerText="ARTG ID(s)" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="Device Class" headerText="Device Class" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="Manufacturer ID" headerText="Manufacturer ID" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </ejs-tooltip>
                  </div>
                </div>
              </ng-template>
              <ng-template #legacyDeviceTemplate>
                <div [@fadeInOut] class="row">
                  <div class="col-sm-12">
                    <div class="col-sm-12 d-flex my-2">
                      <div class="col-sm-2">
                        <span aria-label="Results returned">
                          Results Returned:<span class="badge warning-background badge-bottom-margin  mx-1">
                            {{deviceCount}}
                          </span>records
                        </span>
                      </div>
                      <div class="col-sm-10">
                        <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked" *ngIf="deviceCount > 0">
                        </ejs-checkbox>
                        <span *ngIf="getSelectedItemsCount() > 0" class="ps-3 text-primary">Selected<span
                            class="badge  mx-1">
                            {{getSelectedItemsCount()}}</span>{{itemType === 'model' ? 'models' : 'devices'}} </span>
                      </div>
                    </div>
                    <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)"
                      [enableHtmlParse]="false" target=".e-ellipsistooltip">
                      <ejs-grid #grid [dataSource]="data" allowPaging="true" class="grid-striped" pageSizes="true | []"
                        [pageSettings]="pageOptions" [filterSettings]="filterSettings" [showColumnChooser]="true"
                        [toolbar]="toolbar" (toolbarClick)='toolbarClick($event)' [allowSorting]="true"
                        [allowFiltering]="true" allowScrolling="true" [allowReordering]="true"
                        (dataStateChange)="dataStateChange($event)" (actionBegin)="actionBegin($event)"
                        (actionComplete)="complete($event)" (beforeOpenColumnChooser)="checkboxClick($event)"
                        (dataBound)="dataBound($event)" (created)="gridCreated($event)" (actionFailure)="failure($event)"
                        (load)="load()" height="500" [allowSelection]="true" [selectionSettings]="selectionOptions"
                        (rowDeselected)="rowDeselectedItem($event, 'id')" (keyPressed)="setSelectedRowIndex($event)"
                        (rowSelected)="rowSelectedItem($event, 'id')">
                        <e-columns>
                          <e-column field='select' type='checkbox' width='40' [allowFiltering]="false"
                                    [showInColumnChooser]='false' [visible]='true'>
                          </e-column>
                          <e-column type='string' field='Primary DI' headerText='EUDAMED ID' width='300'
                                    [allowSorting]="false" isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <a href="javascript:void(0)" class="pointer" (keydown)="keydownEnter($event)"
                                 (click)="itemClicked($event)">
                                {{data["Primary DI"]}}
                              </a>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Primary DI Issuing Agency' headerText='EUDAMED ID Issuing Agency'
                                    width='250' clipMode='EllipsisWithTooltip' [allowSorting]="false"></e-column>
                          <e-column type='string' field='Modified By' headerText='Modified By' width='250'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='date' field='Modified Date/Time' headerText='Modified Date/Time' width='210'
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Product SKU' headerText='Product SKU' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Trade Name' headerText='Brand/Trade Name' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Device Description' headerText='Device Description' width='250'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Reference or Catalog Number'
                                    headerText='Reference or Catalog Number' width='280' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Attribute Status' headerText='Attribute Status' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <span class="tooltip-span"
                                    (mouseover)="showTooltip($event, 'Attribute Status')">{{data["Attribute Status"]}}</span>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Validation Status' headerText='Validation Status' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                            <ng-template #template let-data>
                              <div class="validation-div" [ngClass]="getCssClass(data)">
                                <span class="tooltip-span"
                                  (mouseover)="showTooltip($event, 'Validation Status')">{{data['Validation
                                  Status']}}</span>
                              </div>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Company Device Tracking Number'
                                    headerText='Company Device Tracking Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Company Device Batch Number'
                                    headerText='Company Device Batch Number' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Applicable Submission Channels'
                                    headerText='Applicable Submission Channels' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Basic UDI-DI Number' headerText='EUDAMED DI' width='300'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Basic UDI-DI Issuing Agency'
                                    headerText='EUDAMED DI Issuing Agency' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'></e-column>
                          <e-column type='string' field='Basic UDI-DI Attribute Status'
                                    headerText='EUDAMED DI Attribute Status' width='250' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'
                                    [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()"
                                    [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()"></e-column>
                          <e-column type='string' field='Health Authority UDI-DI State'
                                    headerText='Health Authority EUDAMED ID State' width='300' [allowSorting]="false"
                                    clipMode='EllipsisWithTooltip'
                                    [visible]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase()"
                                    [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase()">
                            <ng-template #template let-data>
                              <span class="tooltip-span"
                                    (mouseover)="showTooltip($event, 'Health Authority UDI-DI State')">
                                {{data["Health Authority UDI-DI State"]}}</span>
                            </ng-template>
                          </e-column>
                          <e-column type='string' field='Company Product Cross Reference DI' headerText='Company Product Cross Reference DI' width='200'
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="Sponsor ID" headerText="Sponsor ID" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="ARTG IDs" headerText="ARTG ID(s)" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="Device Class" headerText="Device Class" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                          <e-column type="string" field="Manufacturer ID" headerText="Manufacturer ID" width="180"
                                    [allowSorting]="false" clipMode='EllipsisWithTooltip'>
                          </e-column>
                        </e-columns>
                      </ejs-grid>
                    </ejs-tooltip>
                  </div>
                </div>
              </ng-template>
            </ng-template>
          </ng-container>
        </nav>
        <div [ngbNavOutlet]="tabset"></div>
      </div>
    </div>

    <div *ngIf="downloading" class="col-sm-12">
      <div id="loading"></div>
    </div>
  </div>
</main>
<ng-template #submittemplate let-data>

  <button id="approveselected" class='e-tbar-btn e-tbtn-txt e-control e-btn e-lib'
    *appHideByAccess="permissionsConst.CanSendDataForSubmissionApproval">
    <span class='e-btn-icon fas fa-paper-plane e-icons e-icon-left'></span>
    <span class='e-tbar-btn-text'>Send For Approval</span>
  </button>

</ng-template>

<ng-template #downloadLogTemplate>

  <a id="downloadlog" class='e-tbar-btn e-tbtn-txt e-control e-btn e-lib'
    [ngClass]="{'download-log-disabled' : getDownloadInProgress()}"
    *appHideByAccess="permissionsConst.CanReadData">
    <span class='e-btn-icon far fa-download e-icons e-icon-left' *ngIf="!getDownloadInProgress(); else inProcess"></span>
    <span class='e-tbar-btn-text'>Download Validation Log</span>

    <ng-template #inProcess>
      <div class="loading-dots">
        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
      </div>
    </ng-template>
  </a>
</ng-template>

<ejs-dialog #dialog id="dialog" [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='true'
  [width]='modalWidth' [position]='modalPosition' [visible]='modalVisible' [showCloseIcon]='false' aria-hidden="true"
  [hidden]="!modalVisible" [height]='modalHeight' (overlayClick)="onOverlayClick()">

  <div class="card">
    <div class="card-header bg-primary">
      <h4 class="card-title text-white"> Are you sure?</h4>
    </div>
    <div class="card-body" *ngIf="activeTab === 'device'">
      <div class="px-2 my-2">Do you want to send the selected device(s) for approval?</div>
      <div class="px-2 my-2">Please note – The selected devices that meet all of the following criteria will be sent for
        approval:</div>

      <div class="d-flex flex-column">
        <div class="mx-5">
          <ul>
            <li>Validation Status = Pass <span *ngIf="dataScopeEudamed || dataScopeSwissdamed">or Warning</span></li>
            <li>
              If applicable submission channels are specified, the intended health authority for submission must be
              included
            </li>
            <li *ngIf="dataScopeEudamed || dataScopeSwissdamed">
              Most Recent Submission Status ≠ Submission in Process
            </li>
          </ul>
        </div>
      </div>

    </div>
    <div class="card-body" *ngIf="activeTab === 'model'">
      <div class="px-2 my-2">Do you want to send the selected EUDAMED accepted Basic UDI-DI (s) for approval?</div>
      <div class="px-2 my-2">Please note – The selected Basic UDI-DIs that meet all of the following criteria will be
        sent for approval:
      </div>

      <div class="d-flex flex-column">
        <div class="mx-5">
          <ul>
            <li>Calculated EUDAMED Health Authority State of Basic UDI-DI in Single Source = Registered or Submitted
              <div class="ms-3 mt-2">
                <b>
                  IMPORTANT NOTE:
                </b>
                <span>If the actual state of Basic UDI-DI is still at Submitted state in EUDAMED at the time of
                  submission, your submission will be rejected by EUDAMED.</span>
              </div>
            </li>
            <li>Validation Status = Pass</li>
            <li>
              If applicable submission channels are specified, the intended health authority for submission must be
              included
            </li>
            <li>
              Most Recent Submission Status (Basic UDI-DI Update) ≠ Submission in Process
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="card-footer center-block">
      <button id="btnCancel" class="btn btn-default dialogButton" (click)="submissionCancel($event)"
        data-ripple="true">Cancel</button>
      <button id="btnCreateSubmissionItems" class="btn btn-primary dialogButton" (click)="createSubmissionItems($event)"
        data-ripple="true">Confirm</button>
    </div>
  </div>
</ejs-dialog>
